import { useEffect, useState } from 'react';
import api from '../../../plugins/api';
import Button from '../../../components/Button/Button';
import Select from '../../../components/Select/Select';
import alert from '../../../helpers/alert';
import { COLORS } from '../../../components/Selects/SelectColor';

/**
 * Фотографии модели по цветам. У контейнера есть только одна общая картинка,
 * поэтому в приложении клиент видел один и тот же снимок для любого цвета.
 */
const ContainerColorPhotos = ({ containerId }) => {
  const [groups, setGroups] = useState([]);
  const [color, setColor] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get('/api/crm/cars/containerColorPhotos', { containerId });
      setGroups(data || []);
    } catch (e) {
      alert.error('Не удалось загрузить фотографии по цветам');
    }
  };

  useEffect(() => {
    if (containerId) load();
  }, [containerId]);

  const upload = async (event) => {
    const file = event?.target?.files?.[0];
    event.target.value = '';
    if (!file) return;

    if (!color?.value) {
      alert.error('Сначала выберите цвет');
      return;
    }

    const form = new FormData();
    form.append('containerId', containerId);
    form.append('color', color.value);
    form.append('photo', file);

    setLoading(true);
    try {
      await api.post('/api/crm/cars/uploadContainerColorPhoto', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      alert.success('Фото добавлено');
      await load();
    } catch (e) {
      alert.error(e?.response?.data?.errorMessage || 'Не удалось загрузить фото');
    } finally {
      setLoading(false);
    }
  };

  const remove = async (id) => {
    setLoading(true);
    try {
      await api.post(`/api/crm/cars/deleteContainerColorPhoto?id=${id}`);
      await load();
    } catch (e) {
      alert.error('Не удалось удалить фото');
    } finally {
      setLoading(false);
    }
  };

  const nameOf = (value) =>
    COLORS.find((c) => c.value?.toUpperCase() === value?.toUpperCase())?.label || value;

  return (
    <div style={{ marginTop: 30 }}>
      <p style={{ fontWeight: 600, fontSize: 18, marginBottom: 15 }}>Фотографии по цветам</p>

      <div style={{ display: 'flex', gap: 15, alignItems: 'flex-end', marginBottom: 20 }}>
        <div style={{ minWidth: 240 }}>
          <Select
            options={COLORS}
            label="Цвет"
            placeholder="Выберите цвет"
            value={color}
            onChange={setColor}
          />
        </div>
        <label>
          <input type="file" accept="image/*" onChange={upload} style={{ display: 'none' }} disabled={loading} />
          <span
            style={{
              display: 'inline-block',
              padding: '12px 20px',
              borderRadius: 8,
              background: 'var(--brand-primary)',
              color: '#fff',
              cursor: loading ? 'default' : 'pointer',
              opacity: loading ? 0.6 : 1,
            }}
          >
            {loading ? 'Загрузка…' : 'Добавить фото'}
          </span>
        </label>
      </div>

      {groups.length === 0 ? (
        <p style={{ color: '#6A6A6A', fontSize: 14 }}>
          Пока не загружено ни одной фотографии по цветам — в приложении показывается общее фото модели.
        </p>
      ) : (
        groups.map((group) => (
          <div key={group.color} style={{ marginBottom: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <span
                style={{
                  width: 18,
                  height: 18,
                  borderRadius: '50%',
                  background: group.color,
                  border: '1px solid #ccc',
                  display: 'inline-block',
                }}
              />
              <span style={{ fontWeight: 500 }}>{nameOf(group.color)}</span>
              <span style={{ color: '#6A6A6A', fontSize: 13 }}>({group.photos?.length || 0})</span>
            </div>

            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              {group.photos?.map((photo) => (
                <div key={photo.id} style={{ position: 'relative' }}>
                  <img
                    src={photo.url}
                    alt={group.color}
                    style={{ width: 160, height: 100, objectFit: 'cover', borderRadius: 8 }}
                  />
                  <button
                    type="button"
                    onClick={() => remove(photo.id)}
                    title="Удалить"
                    style={{
                      position: 'absolute',
                      top: 4,
                      right: 4,
                      border: 'none',
                      borderRadius: '50%',
                      width: 24,
                      height: 24,
                      background: 'rgba(0,0,0,0.6)',
                      color: '#fff',
                      cursor: 'pointer',
                      lineHeight: '24px',
                    }}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ContainerColorPhotos;
